import { render, staticRenderFns } from "./ComprasDiretasMeuInteresseCarrossel.vue?vue&type=template&id=20ced556&scoped=true"
import script from "./ComprasDiretasMeuInteresseCarrossel.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasMeuInteresseCarrossel.vue?vue&type=script&lang=js"
import style0 from "./ComprasDiretasMeuInteresseCarrossel.vue?vue&type=style&index=0&id=20ced556&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ced556",
  null
  
)

export default component.exports